import { ADMIN_WALLET_INVOICES, ADMIN_MAX_PLUS_SUBSCRIPTIONS } from '@/store/actions/admin/wallet.actions';

const initialState = {
  invoices: [],
  invoices_meta: {},
  max_plus_subscriptions: [],
  max_plus_subscriptions_meta: {}
};

export default function sms(state = initialState, action) {
  switch (action.type) {
    case ADMIN_WALLET_INVOICES:
      return {
        ...state,
        invoices: action.payload.data,
        invoices_meta: action.payload.meta
      };
    case ADMIN_MAX_PLUS_SUBSCRIPTIONS:
      return {
        ...state,
        max_plus_subscriptions: action.payload.data,
        max_plus_subscriptions_meta: action.payload.meta
      };
    default:
      return state;
  }
}
